import { render, staticRenderFns } from "./ProcedureDomainSearch.vue?vue&type=template&id=73d82cab&"
import script from "./ProcedureDomainSearch.vue?vue&type=script&lang=ts&"
export * from "./ProcedureDomainSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports